import React from "react";
import IProcessedBaseDTO from "../../../models/DTO/IProcessedBaseDTO";
import UIService from "../../../services/UIService";
import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import OwTitle from "../OwTitle/OwTitle";
import "./ProcessResultModal.scss";

type Props = {
    closeModalFn: () => void;
    result: IProcessedBaseDTO;
    title?: string;
};

export const ProcessResultModal = (props: Props) => {
    const { closeModalFn, result, title = "processing_results" } = props;

    const downloadErrorsCsv = () => {
        const rows = [["Item", "Error"]];

        for (const errorDetail of result.errorDetails) {
            // Escape quotes and wrap in quotes if contains comma
            const item = errorDetail.item.includes(",") ? `"${errorDetail.item.replace(/"/g, '""')}"` : errorDetail.item;
            const error = errorDetail.error.includes(",") ? `"${errorDetail.error.replace(/"/g, '""')}"` : errorDetail.error;
            rows.push([item, error]);
        }

        const csvContent = rows.map((row) => row.join(",")).join("\n");
        const filename = `process-errors-${new Date().toISOString().split("T")[0]}.csv`;
        UIService.downloadCSVData(csvContent, filename);
    };

    return (
        <div className="ProcessResultModal p-3">
            <div className="d-flex justify-content-between">
                <OwTitle title={title} leftIconName="fad fa-clipboard-list" tag="h3" />
                <div>
                    <OwButton className="btn-danger" centerIconClass="fas fa-times" fn={closeModalFn} />
                </div>
            </div>

            <div className="stats-section mt-3">
                <div className="row">
                    <div className="col-6">
                        <div className="stat-item d-flex">
                            <OwLabel title="total_processed" className="me-2" />
                            <span className="stat-value">{result.totalProcessed}</span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="stat-item d-flex">
                            <OwLabel title="total_created" className="me-2" />
                            <span className="stat-value">{result.totalCreated}</span>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <div className="stat-item d-flex">
                            <OwLabel title="total_updated" className="me-2" />
                            <span className="stat-value">{result.totalUpdated}</span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="stat-item d-flex">
                            <OwLabel title="total_deleted" className="me-2" />
                            <span className="stat-value">{result.totalDeleted}</span>
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-12">
                        <div className="stat-item d-flex">
                            <OwLabel title="total_errors" className="me-2" />
                            <span className={`stat-value ${result.totalErrors > 0 ? "text-danger fw-bold" : ""}`}>
                                {result.totalErrors}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {result.totalErrors > 0 && result.errorDetails.length > 0 && (
                <div className="error-details-section mt-4">
                    <div className="d-flex justify-content-between">
                        <OwTitle title="error_details" leftIconName="fad fa-exclamation-triangle" tag="h5" />
                        {result.totalErrors > 0 && result.errorDetails.length > 0 && (
                            <div>
                                <OwButton
                                    title="download_error_csv"
                                    className="btn-secondary me-2"
                                    leftIconClass="fas fa-download"
                                    fn={downloadErrorsCsv}
                                />
                            </div>
                        )}
                    </div>

                    <div className="error-table-wrapper mt-2">
                        <table className="table table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        <OwLabel title="item" />
                                    </th>
                                    <th>
                                        <OwLabel title="error" />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {result.errorDetails.map((errorDetail, index) => (
                                    <tr key={index}>
                                        <td>{errorDetail.item}</td>
                                        <td className="text-danger">{errorDetail.error}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <div className="buttons-section d-flex justify-content-end mt-4">
                <OwButton title="ok" className="btn-primary" fn={closeModalFn} />
            </div>
        </div>
    );
};

export default ProcessResultModal;
